export default "__VITE_ASSET__Dx7m$wt5__"